import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "Username", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Password", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Log In")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_UserMessageComponent = _resolveComponent("UserMessageComponent")!
  const _component_PageContentComponent = _resolveComponent("PageContentComponent")!

  return (_openBlock(), _createBlock(_component_PageContentComponent, { class: "user-login-view" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageTitleComponent, { title: "Login" }),
      _createElementVNode("label", null, [
        _hoisted_1,
        _withDirectives(_createElementVNode("input", {
          ref: "usernameElement",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usernameField) = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onUsernameEnter && _ctx.onUsernameEnter(...args)), ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.usernameField]
        ])
      ]),
      _createElementVNode("label", null, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          ref: "passwordElement",
          type: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordField) = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onPasswordEnter && _ctx.onPasswordEnter(...args)), ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.passwordField]
        ])
      ]),
      _createElementVNode("label", null, [
        _createVNode(_component_ButtonComponent, { onClick: _ctx.onLogIn }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_UserMessageComponent, { details: _ctx.userMessage }, null, 8, ["details"])
    ]),
    _: 1
  }))
}